import gql from 'graphql-tag';

export const DraftRedirectQuery = gql`
	query DraftRedirectQuery($contentId: ID!, $draftShareId: String, $status: [String]) {
		content(id: $contentId, draftShareId: $draftShareId, status: $status) {
			nodes {
				id
				links {
					webui
				}
				properties(key: "editor") {
					nodes {
						id
						key
						value
					}
				}
			}
		}
	}
`;
